import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/projectypes/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/project-types/delete`,
        endpoint: `${endpointBackend}gci/project-types/getall`
    }

    let list = {
        labelTitle: 'Lista de Tipos de Projetos',
        labelTitleButtonAdd: 'Incluir novo tipo de projeto',
        fieldsShowOnDelete: ['project_type'],
        columns: [
            {
                name: 'project_type',
                label: 'Nome do Tipo de Projeto',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
